import React, { useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { object } from 'prop-types';
import cn from 'classnames';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import WithAlert from '../../hoc/WithAlert';
import { iFMessage, FMessage } from '../../hoc/IntlComponents';
import MembersStatistics from '../../components/MasterAccount/MembersStatistics';
import AddMemberForm from '../../components/MasterAccount/AddMemberForm';
import MasterConfig from '../../components/MasterAccount/MasterConfig';
import AggregatedStatistics from '../../components/MasterAccount/AggregatedStatistics';
import AddMemberModal from '@modals/AddMemberModal/AddMemberModal';
import { Button } from 'reactstrap';

const propTypes = {
  master: object.isRequired,
};

const defaultProps = {
  master: {},
};

const navs = (intl, master) => {
  if (master && master.master && master.master.approved) {
    return [
      <a className="nav-link" title={iFMessage({ intl, id: 'navigation.master.main' })}>
        <FMessage id="navigation.master.main" />
      </a>,
      <a className="nav-link" title={iFMessage({ intl, id: 'navigation.master.aggregate' })}>
        <FMessage id="navigation.master.aggregate" />
      </a>,
      // <a className="nav-link" title={iFMessage({ intl, id: 'pages.add-member.title' })}>
      //   <FMessage id="pages.add-member.title" />
      // </a>,
    ];
  }
};

const MasterAccountPage = ({ showAlert, intl, master, location }) => {
  const [isModalOpen, setModalOpenState] = useState(false);
  // 1 — список аккаунтов (MembersStatistics), 2 — общая статистика (AggregatedStatistics)
  const [activeTab, setActiveTab] = useState(1);
  const isApprovedMaster = Boolean(master && master.master && master.master.approved);

  const renderTabs = () => {
    const tabs = [];
    if (isApprovedMaster) {
      return [
        <MembersStatistics location={location} key="MembersStatistics" />,
        <AggregatedStatistics location={location} key="AggregatedStatistics" />,
        <AddMemberForm key="AddMemberForm" />,
      ];
    }
    if (master && (!master.master || (master.master && !master.master.approved))) {
      return [<MasterConfig key="MasterConfig" />];
    }
    return tabs;
  };

  return (
    <>
      <Layout title="Мастер аккаунт" className="master-account-layout">
        <Card.Header style={{ margin: 0 }}>
          <FMessage id="navigation.master" />
        </Card.Header>

        {isApprovedMaster && (
          <div className="master-button-wrapper">
            <Button color="primary" onClick={() => setModalOpenState(true)}>
              <FMessage id="navigation.master.connect" />
            </Button>
          </div>
        )}

        <Layout.Col className="master-account">
          {isApprovedMaster && (
            <div className="master-view-switch">
              <a
                href="#accounts"
                id="master-view-switch-accounts"
                className={cn('master-view-switch-link', {
                  'master-view-switch-link--active': activeTab === 1,
                })}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab(1);
                }}
              >
                <FMessage id="navigation.master.main" />
              </a>
              <a
                href="#aggregate"
                id="master-view-switch-general"
                className={cn('master-view-switch-link', {
                  'master-view-switch-link--active': activeTab === 2,
                })}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab(2);
                }}
              >
                <FMessage id="navigation.master.aggregate" />
              </a>
            </div>
          )}
          <Card.NavTabs
            className="master-account-card"
            navItems={navs(intl, master)}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            showAlert={showAlert}
            tabProps={{ master, intl, showAlert }}
          >
            {renderTabs()}
          </Card.NavTabs>
        </Layout.Col>
      </Layout>

      {isModalOpen && (
        <AddMemberModal
          isOpen={isModalOpen}
          handleClose={() => setModalOpenState(false)}
          tabProps={{ master, intl, showAlert }}
        />
      )}
    </>
  );
};

MasterAccountPage.propTypes = propTypes;
MasterAccountPage.defaultProps = defaultProps;

const mapStateToProps = ({ webmaster }) => ({
  master: webmaster.profile.master,
  theme: webmaster.profile.theme,
});

export default connect(mapStateToProps)(WithAlert(injectIntl(MasterAccountPage)));
